import {API_LOGIN, API_WHOAMI, API_LOGOUT, API_UPDATE_ME, API_UPDATE_PROFILE, API_CLIENT, API_TECH} from '../config';
import { switch_api } from './switch_api';

export function userIsLoading(bool) {
  return {
    type: 'USER_IS_LOGGING_IN',
    userIsLoading: bool
  }
}

export function userLoggedInSuccess(fields) {
  return {
    type: 'USER_LOGGED_IN_SUCCESS',
    fields
  }
}

export function userLoggedInFailure(message) {
  return {
    type: 'USER_LOGGED_IN_ERROR',
    message
  }
}

export function userLogoutFailure(message) {
  return {
    type: 'USER_LOGOUT_ERROR',
    message
  }
}


export function userLogoutSuccess(fields) {
  return {
    type: 'USER_LOGOUT_SUCCESS',
    fields
  }
}

export function userUpdateProfileSuccess(fields) {
  return {
    type: 'USER_UPDATE_PROFILE_SUCCESS',
    fields
  }
}

export function initializeUser() {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    dispatch(userIsLoading(true));
    fetch(API_WHOAMI, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_WHOAMI }: " + response.statusText);
        dispatch(userIsLoading(false));
      }
      return response;
    })
    .then((response) => response.json())
    .then((fields) => dispatch(userLoggedInSuccess(fields)))
    .then((fields) => {
      fields.username ? 
        (fields.is_client ? localStorage.setItem('API', API_CLIENT) : localStorage.setItem('API', API_TECH)) : null
    })
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
      dispatch(userIsLoading(false));
    })
  }
}

export function updateUser(data) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_UPDATE_ME), {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify(data)
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_UPDATE_ME }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((fields) => dispatch(userUpdateProfileSuccess(fields)))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function updateProfile(data) {
  let token =  localStorage.getItem('token')
  console.warn(data)
  return (dispatch) => {
    fetch(switch_api(API_UPDATE_PROFILE), {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify(data)
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_UPDATE_ME }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((fields) => console.warn(fields))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function loginUser(login, password) {
  return (dispatch) => {
    fetch(API_LOGIN, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Basic '+btoa(login+':'+password), 
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      // credentials: 'include',
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_LOGIN }: " + response.statusText);
        // throw Error(response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((fields) => dispatch(fields.token ? (
        localStorage.setItem('token',fields.token ),
        userLoggedInSuccess(fields)
      ) : userLoggedInFailure(fields.detail))
    )
    .then((fields) => {
      fields.fields.user ? 
        (fields.fields.user.is_client ? localStorage.setItem('API', API_CLIENT) : localStorage.setItem('API', API_TECH)) : null
    })
    .catch((e) => {
      dispatch(userLoggedInFailure(' '))
    })
  }
}

export function logoutUser() {
  let token =  localStorage.getItem('token')
  return (dispatch, getState) => {
    fetch(API_LOGOUT, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include' // send cookies for CORS requests
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed logging out on { API_LOGOUT}");
        throw Error(response.statusText);
      }
      return response;
    })
    // .then((response) => response.json())
    .then((response) => dispatch(userLogoutSuccess()))
    .catch((err) => dispatch(userLogoutFailure('logout failure: ' + err)))
  }
}





// WEBPACK FOOTER //
// ./src/actions/auth.js